import i18n from "../../i18n";

// Labels are looked up when read (not when the module loads), so they follow the active language.
const tr = (key) => i18n.t(key);
const lazy = (obj) => {
  Object.keys(obj).forEach((k) => {
    ["label", "short"].forEach((f) => {
      if (typeof obj[k][f] === "string") {
        const key = obj[k][f];
        Object.defineProperty(obj[k], f, { get: () => tr(key), enumerable: true });
      }
    });
  });
  return obj;
};

// A hint is offered on its own once the learner has made no progress (no cue ticked, no hint
// shown) for this long while cues remain; the learner can always ask for one with the lightbulb.
export const HINT_STUCK_AFTER_S = 45;

// Authoring (blank programs, "create with AI", adding scenarios) is switched off: the training
// content is static (it comes from the call-analysis referential). The screens and API stay in place.
export const AUTHORING_ENABLED = process.env.REACT_APP_TRAINING_AUTHORING === "true";

export const SENTIMENTS = lazy({
  satisfied: { label: "Satisfait", tone: "good", rank: 3 },
  neutral: { label: "Neutre", tone: "plain", rank: 2 },
  dissatisfied: { label: "Mécontent", tone: "warn", rank: 1 },
  frustrated: { label: "Excédé", tone: "bad", rank: 0 },
});

export const DIRECTIONS = lazy({
  incoming: { label: "Appel entrant", short: "Entrant" },
  outgoing: { label: "Appel sortant", short: "Sortant" },
});

// Client dossier (the context shown to the learner): status of a document and what kind it is.
export const DOC_STATUS = lazy({
  unpaid: { label: "À régler", tone: "warn" },
  overdue: { label: "En retard", tone: "bad" },
  paid: { label: "Réglée", tone: "good" },
  held: { label: "Retenue", tone: "warn" },
  rejected: { label: "Rejeté", tone: "bad" },
  scheduled: { label: "Programmé", tone: "plain" },
  credited: { label: "Avoir disponible", tone: "good" },
});
export const DOC_TYPES = lazy({
  invoice: { label: "Facture" },
  credit_note: { label: "Avoir" },
  payment: { label: "Règlement" },
  direct_debit: { label: "Prélèvement" },
  statement: { label: "Relevé" },
});

export const LEVEL_STATUS = lazy({
  locked: { label: "Verrouillé", tone: "plain" },
  in_progress: { label: "En cours", tone: "brand" },
  ready_for_validation: { label: "À valider", tone: "warn" },
  validated: { label: "Validé", tone: "gold" },
});

export const SCENARIO_STATUS = lazy({
  draft: { label: "Brouillon", tone: "plain" },
  in_review: { label: "En relecture", tone: "warn" },
  published: { label: "Publié", tone: "good" },
  archived: { label: "Archivé", tone: "plain" },
});

export const TARGET_STATUS = lazy({
  done: { label: "Objectif atteint", tone: "gold" },
  on_track: { label: "Dans les temps", tone: "good" },
  at_risk: { label: "À surveiller", tone: "warn" },
  late: { label: "En retard", tone: "bad" },
  none: { label: "Sans objectif", tone: "plain" },
});

const PALIERS = ["Découverte", "Intermédiaire", "Avancé", "Complexe", "Certification"];
export const PALIER_NAMES = PALIERS.map(() => null);
PALIERS.forEach((key, i) =>
  Object.defineProperty(PALIER_NAMES, i, { get: () => tr(key), enumerable: true })
);

export const DEFAULT_PASS_SCORE = 70;

export const scoreTone = (score, pass = DEFAULT_PASS_SCORE) => {
  if (score == null) return "plain";
  if (score >= pass + 10) return "good";
  if (score >= pass) return "brand";
  if (score >= pass - 15) return "warn";
  return "bad";
};

export const DEFAULT_RUBRIC = [
  { id: "posture", name: "Posture & accueil", max_points: 15, description: "" },
  { id: "identification", name: "Identification & conformité", max_points: 15, description: "" },
  { id: "accounting", name: "Maîtrise comptable", max_points: 25, description: "" },
  { id: "negotiation", name: "Négociation & calme", max_points: 25, description: "" },
  { id: "closing", name: "Conclusion & traçabilité", max_points: 20, description: "" },
];

const SOURCES = {
  referential: "Référentiel client",
  ai_generated: "Généré par l'IA",
  manual: "Créé à la main",
};
export const SOURCE_LABELS = {};
Object.entries(SOURCES).forEach(([k, key]) =>
  Object.defineProperty(SOURCE_LABELS, k, { get: () => tr(key), enumerable: true })
);
